import React, { memo } from 'react';
export function IntroNarrative() {
  return <section id="intro" className="py-12" data-id="element-158">
      <div className="prose prose-slate max-w-none" data-id="element-159">
        <p className="mb-4" data-id="element-160">Listen.</p>
        <p className="mb-4" data-id="element-161">
          I know you're reading this through squinted eyes. Maybe with the
          brightness turned all the way down. Maybe you've already taken your
          second Excedrin today and it's not even noon.
        </p>
        <p className="mb-4" data-id="element-162">I see you.</p>
        <p className="mb-4" data-id="element-163">
          The one who's memorized every bathroom location at work in case the
          nausea hits. Who's canceled on friends so many times they've stopped
          inviting you. Who's spent entire weekends in bed with blackout
          curtains, ice packs melting into your pillow, praying this one passes
          before Monday.
        </p>
        <p className="mb-4" data-id="element-164">I was you for 12 years.</p>
        <p className="mb-4" data-id="element-165">
          $47,000 in treatments. That's what I calculated last spring when I
          finally added it all up. Neurologists, triptans, Botox injections,
          acupuncture, that $3,200 Cefaly device that felt like being
          electrocuted. Even a "migraine specialist" in Manhattan who charged
          $850 for a consultation just to tell me to "manage my stress better."
        </p>
        <p className="mb-4" data-id="element-166">
          Then, three months ago, something happened that I still can't fully
          explain.
        </p>
        <p className="mb-4" data-id="element-167">
          My sister-in-law — the skeptical one who thinks everything's a scam —
          handed me this weird-looking device at Thanksgiving. "Just try it,"
          she said. "It's the only thing that helped Mom."
        </p>
        <p className="mb-4" data-id="element-168">
          Fifteen minutes later, I was crying in her guest bathroom.
        </p>
        <p className="mb-4" data-id="element-169">Not from pain. From the absence of it.</p>
        <p className="mb-4" data-id="element-170">
          For the first time in 4,380 days, the vise-grip around my skull...
          released.
        </p>
        <p className="mb-4" data-id="element-171">
          What I discovered that day led me down a research rabbit hole that
          changed everything I thought I knew about my "incurable" condition.
          And if you'll give me the next 7 minutes, I'll show you exactly why
          this strange discovery is helping thousands of us finally break free
          from the migraine prison we thought was our life sentence.
        </p>
      </div>
      <div className="mt-8 bg-white p-4 rounded-lg shadow-sm border border-[#F1F5F9]" data-id="element-172">
        <h3 className="font-medium text-[#0F172A] mb-2" data-id="element-173">
          What you'll see on this page:
        </h3>
        <ul className="text-sm space-y-2 text-[#334155]" data-id="element-174">
          <li className="flex items-center" data-id="element-175">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#0EA5B7] mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-176">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4" data-id="element-177" />
            </svg>
            The hidden truth about "sinus headaches"
          </li>
          <li className="flex items-center" data-id="element-178">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#0EA5B7] mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-179">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4" data-id="element-180" />
            </svg>
            Why your medications might be making things worse
          </li>
          <li className="flex items-center" data-id="element-181">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#0EA5B7] mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-182">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4" data-id="element-183" />
            </svg>
            The precise temperature that changes everything
          </li>
          <li className="flex items-center" data-id="element-184">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#0EA5B7] mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-185">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4" data-id="element-186" />
            </svg>
            Real recovery stories from former sufferers
          </li>
          <li className="flex items-center" data-id="element-187">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#0EA5B7] mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-188">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4" data-id="element-189" />
            </svg>
            How one device replaces thousands in treatments
          </li>
        </ul>
      </div>
    </section>;
}